export const validateRule = (currentRule: RuleItem) => {
  let rule: RuleItem | null = null;
  const r = {
    ...currentRule,
    listTips: false,
    nameStatus: false,
    leftObjectStatus: '',
    rightObjectStatus: '',
    tolerateDiffStatus: '',
    directionTypeStatus: '',
    directionValueStatus: '',
    conditionDTOList: (currentRule?.conditionDTOList || [])?.map((c) => ({
      ...c,
      compareKeyStatus: '',
      compareTypeStatus: '',
      compareValueStatus: '',
    })),
  };
  const leftObject = r?.leftObjectDTO;
  const rightObject = r?.rightObjectDTO;
  const ruleExamLeftObjects = r?.examineObjectsLeft || [...(leftObject?.presetObjectList || [])];
  const ruleExamRightObjects = r?.examineObjectsRight || [...(rightObject?.presetObjectList || [])];

  if (r?.name === '') {
    rule = { ...r, ...(rule || {}) };
    rule.nameStatus = 'error';
    rule.listTips = true;
  }
  if (ruleExamLeftObjects.length === 0) {
    rule = { ...r, ...(rule || {}) };
    rule.listTips = true;
    rule.leftObjectStatus = 'error';
  }
  if (ruleExamRightObjects.length === 0 && r?.type !== 3) {
    rule = { ...r, ...(rule || {}) };
    rule.listTips = true;
    rule.rightObjectStatus = 'error';
  }
  //硬碰撞
  if (r.type === 1 && r.tolerateDiff === '') {
    rule = { ...r, ...(rule || {}) };
    rule.tolerateDiffStatus = 'error';
    rule.listTips = true;
  }
  //软碰撞
  if (r.type === 2) {
    if (r?.directionType === '') {
      rule = { ...r, ...(rule || {}) };
      rule.directionTypeStatus = 'error';
      rule.listTips = true;
    }
    if (!r?.directionValue && r?.directionValue !== 0) {
      rule = { ...r, ...(rule || {}) };
      rule.directionValueStatus = 'error';
      rule.listTips = true;
    }
    if (r.tolerateDiff === '') {
      rule = { ...r, ...(rule || {}) };
      rule.tolerateDiffStatus = 'error';
      rule.listTips = true;
    }
  }
  //属性判断
  if (r.type === 3) {
    if (!r?.conditionDTOList || r?.conditionDTOList?.length === 0) {
      rule = { ...r, ...(rule || {}) };
      rule.listTips = true;
    } else {
      r?.conditionDTOList?.forEach((c) => {
        if (!c?.compareKey) {
          c.compareKeyStatus = 'error';
          rule = { ...r, ...(rule || {}) };
          rule.listTips = true;
        }
        if (!c?.compareType) {
          c.compareTypeStatus = 'error';
          rule = { ...r, ...(rule || {}) };
          rule.listTips = true;
        }
        if (!c?.compareValue && c?.compareValue !== 0) {
          c.compareValueStatus = 'error';
          rule = { ...r, ...(rule || {}) };
          rule.listTips = true;
        }
      });
    }
  }
  if (rule) {
    if (!rule.template) {
      rule.errorMessage = '规则不完整：部分预置内容被删除';
    }
    return rule;
  }
  return null;
};
